import { typeStyle } from '@clim/client-core';
import type { DossierTypeRecord } from '@clim/domain';

/** Signature visuelle d'une activité : icône + libellé + couleur (jamais la couleur seule). */
export function TypeTag({ type }: { type: DossierTypeRecord | undefined }) {
  const s = typeStyle(type);
  return (
    <span className="type-tag" style={{ borderColor: s.color, color: s.color }}>
      <span aria-hidden>{s.icon}</span> {s.label}
    </span>
  );
}
